import { render, staticRenderFns } from "./BladeEditor.vue?vue&type=template&id=b76c3c2c&scoped=true"
import script from "./BladeEditor.vue?vue&type=script&lang=js"
export * from "./BladeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76c3c2c",
  null
  
)

export default component.exports